import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  Modal,
  Row,
  Select,
  Spin,
  TableColumnsType,
  TableProps,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import "./quiz-preview.scss";
import TableData from "../table-data/TableData";
import { DataType } from "./constants";
import { getQuizById, getVersionsOfQuiz } from "../../service/course-construct";
import { QuestionTypeEnum } from "../../constants";
import ChooseText from "../course-content/learning-course/components/quiz-screen/quiz/choose-text/ChooseText";
import ChooseImage from "../course-content/learning-course/components/quiz-screen/quiz/choose-image";
import ChooseVideo from "../course-content/learning-course/components/quiz-screen/quiz/choose-video";
import TrueOrFalse from "../course-content/learning-course/components/quiz-screen/quiz/true-or-false";
import ChooseMultiText from "../course-content/learning-course/components/quiz-screen/quiz/choose-multi-text";
import ChooseMultiImage from "../course-content/learning-course/components/quiz-screen/quiz/choose-multi-image";
import ChooseMultiVideo from "../course-content/learning-course/components/quiz-screen/quiz/choose-multi-video";
import Connect from "../course-content/learning-course/components/quiz-screen/quiz/connect";
import ShortText from "../course-content/learning-course/components/quiz-screen/quiz/short-text";
import FileUpload from "../course-content/learning-course/components/quiz-screen/quiz/file-upload";
import Video from "../course-content/learning-course/components/quiz-screen/quiz/video";
import Mp3 from "../course-content/learning-course/components/quiz-screen/quiz/mp3";
import DropDown from "../course-content/learning-course/components/quiz-screen/quiz/drop-down";
import FillText from "../course-content/learning-course/components/quiz-screen/quiz/fill-text/FillText";
import Calculated from "../course-content/learning-course/components/quiz-screen/quiz/caculated";
import Numerical from "../course-content/learning-course/components/quiz-screen/quiz/numerical";
import Essay from "../course-content/learning-course/components/quiz-screen/quiz/essay";
import LongText from "../course-content/learning-course/components/quiz-screen/quiz/long-text";
import { getQuizInUseInfo } from "../../service/quiz-preview";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../config/routes";

type QuizPreviewProps = {
  quizId: number;
  questions?: any;
  fullHeight?: boolean;
  isOpenModal: boolean;
  showUsedTable?: boolean;
  footer?: React.ReactNode;
  hiddenVersionSelect?: boolean;
  setIsOpenModal: (value: boolean) => void;
  setQuizDetailId: (value: number) => void;
  setNewListQuestions?: (value: any) => void;
  setChangeVersionLoading?: (value: boolean) => void;
};

const QuizPreview = ({
  quizId,
  footer,
  questions,
  fullHeight,
  isOpenModal,
  showUsedTable,
  hiddenVersionSelect,
  setIsOpenModal,
  setQuizDetailId,
  setNewListQuestions,
  setChangeVersionLoading,
}: QuizPreviewProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState<number>(10);
  const [quizDetail, setQuizDetail] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [selectedQuiz, setSelectedQuiz] = useState<any>({});
  const [quizVersions, setQuizVersions] = useState<any>([]);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [dataQuizInUse, setDataQuizInUse] = useState<any>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [quizVersionId, setQuizVersionId] = useState<number>(0);
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
  const [quizLoading, setQuizLoading] = useState<boolean>(false);
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [quizVersionsDefault, setQuizVersionsDefault] = useState<any>([]);

  // data columns
  const dataColumns: TableColumnsType<DataType> = [
    {
      title: t("Tên bài đánh giá", "Tên bài đánh giá"),
      dataIndex: "unitName",
      key: "unitName",
      width: 10,
      render: (_: any, record: any) => (
        <Typography.Link
          onClick={() =>
            navigate(
              `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/${record.courseId}/add-lesson?unitId=${record.unitId}&blockId=${record.blockId}&mode=setting`,
              {
                state: {
                  quizIdFromBank: quizId,
                },
              }
            )
          }
        >
          {record.unitName}
        </Typography.Link>
      ),
    },
    {
      title: t("Tên khóa học", "Tên khóa học"),
      dataIndex: "courseName",
      key: "courseName",
      width: 10,
      render: (_: any, record: any) => (
        <Typography.Link
          onClick={() =>
            navigate(
              `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/${record.courseId}/?tab=2`
            )
          }
        >
          {record.courseName}
        </Typography.Link>
      ),
    },
    {
      title: t("Mã khóa học", "Mã khóa học"),
      dataIndex: "courseCode",
      key: "courseCode",
      width: 5,
    },
  ];

  // render question by type
  const renderQuestionByType = (quiz: any) => {
    const data = {
      ...quiz,
      questions:
        quiz?.answers !== undefined
          ? typeof quiz?.answers === "string"
            ? JSON.parse(quiz?.answers)
            : quiz?.answers
          : "",
    };

    switch (quiz?.type) {
      case QuestionTypeEnum.CHOOSE_TEXT:
        return <ChooseText data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_IMAGE:
        return <ChooseImage data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_VIDEO:
        return <ChooseVideo data={data} hiddenIndex/>;
      case QuestionTypeEnum.TRUE_OR_FALSE:
        return <TrueOrFalse data={data} hiddenIndex/>;
      case QuestionTypeEnum.DROP_DOWN:
        return <DropDown data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_MULTI_TEXT:
        return <ChooseMultiText data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_MULTI_IMAGE:
        return <ChooseMultiImage data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_MULTI_VIDEO:
        return <ChooseMultiVideo data={data} hiddenIndex/>;
      case QuestionTypeEnum.CONNECT:
        return <Connect data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.SHORT_TEXT:
        return <ShortText data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.LONG_TEXT:
        return <LongText data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.FILE_UPLOAD:
        return <FileUpload data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.VIDEO:
        return <Video data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.MP3:
        return <Mp3 data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.FillText:
        return <FillText data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.CALCULATED:
        return <Calculated data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.CALCULATED_SIMPLE:
        return <Calculated data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.CALCULATED_MULTI:
        return <Calculated data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.NUMERICAL:
        return <Numerical data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.ESSAY:
        return <Essay data={data} disabled hiddenIndex/>;
      default:
        break;
    }
  };

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // handle close modal
  const handleClose = () => {
    setIsOpenModal(false);
  };

  // get detail quiz
  const getQuizDetailById = async () => {
    setQuizLoading(true);
    setChangeVersionLoading && setChangeVersionLoading(true);
    try {
      const res = await getQuizById(quizId);
      if (res.status === 200) {
        setQuizDetail(res.data.body);
        setQuizLoading(false);
        setChangeVersionLoading && setChangeVersionLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setChangeVersionLoading && setChangeVersionLoading(false);
    }
  };

  // get versions quiz
  const getQuizVersionsById = async () => {
    setQuizLoading(true);
    setChangeVersionLoading && setChangeVersionLoading(true);
    try {
      const res = await getVersionsOfQuiz(quizId);
      if (res.status === 200) {
        const versions = res.data.data?.map((item: any) => ({
          value: item.quizId,
          label: item.version ? `Phiên bản ${item.version}` : t("Bản nháp", "Bản nháp"),
        }));
        setQuizVersions(versions);
        setQuizVersionsDefault(res.data?.data);
        setQuizLoading(false);
        setChangeVersionLoading && setChangeVersionLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setQuizLoading(false);
      setChangeVersionLoading && setChangeVersionLoading(false);
    }
  };

  // get info unit used quiz
  const getInfoQuizUsed = async () => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      quizId: quizId,
    };
    try {
      const res = await getQuizInUseInfo(dataReq);
      if (res.status === 200) {
        setDataQuizInUse(res.data.data?.content);
        setTotalRecords(res.data.data?.totalElements);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect
  useEffect(() => {
    if (isOpenModal && quizId !== 0) {
      getQuizDetailById();
      getQuizVersionsById();
    }
  }, [isOpenModal, quizId]);

  useEffect(() => {
    if (isOpenModal && quizId !== 0) {
      getInfoQuizUsed();
    }
  }, [isOpenModal, quizId, pageSize, pageNumber]);

  useEffect(() => {
    if (!isOpenModal) {
      setIsFirstTime(true);
    }
  }, [isOpenModal]);

  // Luồng thay đổi câu hỏi theo version: (1) (2) (3) (4) (5)
  useEffect(() => {
    if (quizId !== 0) {
      setQuizVersionId(quizId);

      // (1)  Lưu lại câu hỏi được chọn
      if (questions && isFirstTime) {
        const quiz = questions.find((item: any) => item.id === quizId);
        setSelectedQuiz(quiz);
        setIsFirstTime(false);
      }
    }
  }, [quizId]);

  useEffect(() => {
    if (
      quizDetail &&
      selectedQuiz &&
      Object.keys(quizDetail).length !== 0 &&
      Object.keys(selectedQuiz).length !== 0 &&
      // quizDetail.id !== selectedQuiz.id &&
      quizVersionsDefault.length > 0 &&
      setNewListQuestions
    ) {
      // (2)  Lấy ra phiên bản được chọn
      const version = quizVersionsDefault.find(
        (quiz: any) => quiz.quizId === quizDetail.id
      )?.version;

      // (3) Thay đổi các giá trị cần thiết cho câu hỏi được chọn (1) để hiển thị và truyền lên payload khi thêm
      const quiz = {
        ...selectedQuiz,
        id: quizDetail.id,
        type: quizDetail.type,
        questionBankVersion: version,
        question: quizDetail.question,
      };

      // (4) Tạo obj để map toàn bộ câu hỏi sau khi thay đổi thông tin của câu hỏi được chọn phiên bản
      // Thay đổi obj (3) vào vị trí của câu hỏi đã được chọn và giữ nguyên các câu hỏi khác
      const mapQuiz = questions.map((item: any) =>
        item.id === selectedQuiz.id ? quiz : item
      );

      // (5) Gửi obj đã chỉnh sửa (4) ra bên ngoài để thay thế danh sách câu hỏi ban đầu khi bấm lưu
      setNewListQuestions(mapQuiz);
    }
  }, [quizDetail, quizVersionsDefault]);

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{t("Nội dung câu hỏi", "Nội dung câu hỏi")}</span>
          {hiddenVersionSelect ? (
            <span style={{ marginRight: "2rem", fontWeight: "normal", color: "#676767" }}>
              {
                quizVersions.find(
                  (version: any) => version.value === quizVersionId
                )?.label
              }
            </span>
          ) : (
            <Select
              value={quizVersionId}
              options={quizVersions}
              disabled={quizLoading}
              onChange={(e) => {
                setQuizDetailId(e);
                setQuizVersionId(e);
              }}
              style={{ minWidth: "13%", marginRight: "2rem" }}
            />
          )}
        </div>
      }
      open={isOpenModal}
      onCancel={handleClose}
      maskClosable={false}
      footer={footer ?? null}
      className={`quiz-preview-modal`}
    >
      <Row className="quiz-content">
        <Col
          span={24}
          style={fullHeight ? { height: "100%" } : {}}
          className={`quiz-content__detail ${
            quizLoading ? "quiz-loading" : ""
          } ${!showUsedTable ? "hidden-used-table" : ""}`}
        >
          {quizLoading ? (
            <Spin size="large" />
          ) : (
            renderQuestionByType(quizDetail)
          )}
        </Col>
        {showUsedTable ? (
          <>
            <Typography.Title level={5} className="quiz-content__title">
              {t("Danh sách học liệu sử dụng", "Danh sách học liệu sử dụng")}{" "}
            </Typography.Title>
            <Col span={24} className="quiz-content__used-list">
              <TableData
                dataTable={dataQuizInUse}
                dataColumns={dataColumns}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                pageSize={pageSize}
                pagination={true}
                scroll={{ x: 900, y: 120 }}
                totalRecords={totalRecords}
                loadingTable={loading}
                handleTableChangeProps={handleTableChange}
              />
            </Col>
          </>
        ) : null}
      </Row>
    </Modal>
  );
};

export default QuizPreview;
